import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import type { ReactElement, ReactNode } from 'react';

import { theme } from './theme';

/**
 * Thin wrapper around MUI's ThemeProvider so consumers (App, test
 * helpers) don't have to know about the theme object directly. Also
 * mounts `<CssBaseline>` so the mockup-canonical body background +
 * font smoothing kick in once globally.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }): ReactElement => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
